import actions from './actions'

export default function PartTransferDeliveredsReducer(state = { loading: false }, action) {
  switch (action.type) {
    case actions.REQUESTING:
      return {
        ...state,
        loading: true,
        editing: null,
        saveSuccess: false,
      }
    case actions.LIST_PARTTRANSFERARRIVED:
      return {
        ...state,
        result: action.result,
        loading: false,
        saveSuccess: false,
      }
    case actions.EDIT_PARTTRANSFERARRIVED:
      return {
        ...state,
        editing: action.result,
        loading: false,
        saveSuccess: false,
      }
    case actions.RESET_PARTTRANSFERARRIVED:
      return {
        ...state,
        editing: null,
        loading: false,
        saveSuccess: false,
      }
    case actions.NEW_PARTTRANSFERARRIVED:
      return {
        ...state,
        editing: { partTransferDeliveredID: 0 },
        loading: false,
        saveSuccess: false,
      }
    case actions.CREATE_PARTTRANSFERARRIVED_RECIEVED ||
      actions.UPDATE_PARTTRANSFERARRIVED_RECIEVED ||
      actions.DELETE_PARTTRANSFERARRIVED_RECIEVED:
      return {
        ...state,
        editing: { partTransferDeliveredID: 0 },
        loading: false,
        saveSuccess: true, // mark
      }
    case actions.RESPONSE_ERROR:
      return {
        ...state,
        loading: false,
        error: true,
        saveSuccess: false,
        message: action.message,
      }
    default:
      return state
  }
}
